import styled from "styled-components";
import { device } from "../device";

const SubTitle = styled.div`
    margin-bottom: 64px;

    font-size: 18px;
    font-weight: 500;
    @media ${device.lg} {
        font-size: 24px;
        font-weight: 500;
    }
`;

export default SubTitle